<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <UserToolbar
      v-if="account && Object.keys(account).length !== 0 && shouldShowToolbar()"
      :account="account"
    />

    <b-card v-if="Object.keys(currentGoogleAd).length">
      <GoogleAdsToolbar :title="currentGoogleAd.title" />
    </b-card>

    <GoogleAdsForm
      v-if="Object.keys(currentGoogleAd).length"
      :google-ad="currentGoogleAd"
    />
  </div>
</template>

<script>
import { isOfferWallOperator } from '@/auth/roles'
import useJwt from '@/auth/jwt/useJwt'
import { BCard } from 'bootstrap-vue'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUserData } from '@/auth/utils'
import GoogleAdsForm from './GoogleAdsForm.vue'
import GoogleAdsToolbar from './GoogleAdsToolbar.vue'
import { apiToForm } from './googleAdsTransform'

function isOfferWallOperatorUser() {
  return isOfferWallOperator(getUserData())
}

export default {
  components: {
    BCard,
    GoogleAdsForm,
    GoogleAdsToolbar,
    Breadcrumbs,
    UserToolbar,
  },
  data() {
    return {
      breadcrumbItems: [],
      account: {},
      currentGoogleAd: {},
    }
  },
  created() {
    this.getUserData()
  },
  methods: {
    shouldShowToolbar() {
      if (!isOfferWallOperatorUser()) return true
      const currentUser = getUserData()
      return String(this.$route.params.userId) === String(currentUser?.id)
    },
    setBreabcrumbs() {
      if (this.$route.params.userId !== undefined) {
        if (this.account && this.account.name) {
          // Full breadcrumbs with user name and profile link
          this.breadcrumbItems = [
            {
              text: 'users',
              to: '/users',
            },
            {
              text: this.account.name,
              to: `/users/${this.$route.params.userId}`,
            },
            {
              text: this.$t('google_ads.list'),
              to: `/users/${this.$route.params.userId}/offerwall`,
            },
            {
              text: this.currentGoogleAd.title,
              active: true,
            },
          ]
        } else {
          // Simplified breadcrumbs when user data is unavailable
          this.breadcrumbItems = [
            {
              text: 'OfferWall',
              to: '/offerwall',
            },
            {
              text: this.currentGoogleAd.title,
              active: true,
            },
          ]
        }
      } else {
        this.breadcrumbItems = [
          {
            text: this.$t('google_ads.list'),
            active: true,
          },
        ]
      }
    },
    async getUserData() {
      try {
        const responseData = await useJwt.getUser(this.$route.params.userId)
        this.account = responseData.data.account || {}
      } catch (e) {
        // OfferWall operators may not have access to some users (e.g. admins)
        this.account = {}
      }
      this.getGoogleAd()
    },
    async getGoogleAd() {
      try {
        const responseData = await useJwt.getGoogleWidget(this.$route.params.adId)
        const apiData = responseData.data.googlewidget || {}
        // Transform API data to form structure
        this.currentGoogleAd = apiToForm(apiData)
        this.setBreabcrumbs()
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('form.error'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        this.currentGoogleAd = {}
      }
    },
  },
}

</script>
